import endOfDayFn from 'date-fns/endOfDay'
import toDate, { dateParamType } from '~/utils/gcxDates/toDate'
type Result = Date

const endOf = (dateProp: dateParamType) => {
  const date = toDate(dateProp)
  const result: Result = endOfDayFn(date)
  return result
}

export default endOf
